module.exports = __webpack_public_path__ + "static/media/mic.8ef6d34a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/features/mic.svg
// module id = 132
// module chunks = 0